import React, { useCallback, useEffect, useState } from 'react';
import { TooltipProvider } from '../ui/tooltip';
import { BridgeAssistantLauncher } from './BridgeAssistantLauncher';
import { BridgeAssistantPanel } from './BridgeAssistantPanel';
import { QUICK_PROMPTS } from '../../content/bridgeAssistantContent';
import { BRIDGE_ASSISTANT_OPEN_EVENT } from '../../utils/bridgeAssistant';
import useBridgeAssistantContext from '../../hooks/useBridgeAssistantContext';

/**
 * Global Bridge Assistant — logged-in app pages only (mounted from App.js).
 */
export function BridgeAssistantRoot() {
  const ctx = useBridgeAssistantContext();
  const [open, setOpen] = useState(false);

  const handleToggle = useCallback((next) => {
    setOpen(typeof next === 'boolean' ? next : (v) => !v);
  }, []);

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === 'Escape' && open) {
        setOpen(false);
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [open]);

  useEffect(() => {
    const onOpen = () => setOpen(true);
    window.addEventListener(BRIDGE_ASSISTANT_OPEN_EVENT, onOpen);
    return () => window.removeEventListener(BRIDGE_ASSISTANT_OPEN_EVENT, onOpen);
  }, []);

  return (
    <TooltipProvider delayDuration={300}>
      <BridgeAssistantLauncher
        open={open}
        onToggle={handleToggle}
        hasMobileBottomNav={ctx.hasMobileBottomNav}
      />
      <BridgeAssistantPanel
        open={open}
        onClose={() => setOpen(false)}
        ctx={ctx}
        quickPrompts={QUICK_PROMPTS}
      />
    </TooltipProvider>
  );
}

export default BridgeAssistantRoot;
